// redux-thunk tutorial https://alligator.io/redux/redux-thunk

import { API_URL } from '../config';


export const AUTH_BASE_URL = `${API_URL}auth/`;
